// extracted by mini-css-extract-plugin
export default {"tags":"PJUlXNLW","form":"dKIn5XeT","total":"QF_2QTjY"};